import React from 'react'

import { Box } from '@mui/material'

import { Size } from '../../utils/types'
import FeatherIcon from '../FeatherIcon/FeatherIcon'
import { IconName } from '../FeatherIcon/FeatherIcon.types'
import Tooltip from './Tooltip'

interface TooltipIconProps {
  tooltip: React.ReactNode
  component?: React.ElementType
  display?: 'flex' | 'inline-flex'
}

const TooltipIcon = ({ tooltip, component = 'div', display = 'flex' }: TooltipIconProps) => (
  <Tooltip content={tooltip} trigger="mouseenter focus">
    <Box component={component} display={display} sx={{ ml: 0.5, cursor: 'pointer' }}>
      <FeatherIcon name={IconName.HelpCircle} size={Size.Small} />
    </Box>
  </Tooltip>
)

export default React.memo(TooltipIcon)
